export function Currency(props) {
  const value = Number(props.amount) || 0;
  const absValue = Math.abs(value);
  const formatted = `$${absValue
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  const isNegative = value < 0;
  const classes = [
    "currency-value",
    isNegative ? "currency-value--negative" : "",
    props.className || "",
  ]
    .join(" ")
    .trim();

  return (
    <span className={classes}>{isNegative ? `(${formatted})` : formatted}</span>
  );
}
